import { useQuery } from '@tanstack/react-query';
import { api } from '@weebee/api';
import { queryKeys } from '../query-keys';

export function usePlayerProfile() {
  return useQuery({
    queryKey: queryKeys.player.profile(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/player/profile');
      if (error) throw error;
      return data;
    },
    staleTime: 60_000,
  });
}

export function usePlayerRank() {
  return useQuery({
    queryKey: queryKeys.player.rank(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/ranking/rank');
      if (error) throw error;
      return data;
    },
    staleTime: 60_000,
  });
}

export function useCarbonStats() {
  return useQuery({
    queryKey: queryKeys.player.carbon(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/player/carbon-stats');
      if (error) throw error;
      return data;
    },
    staleTime: 5 * 60_000,
  });
}

export function useStreaks() {
  return useQuery({
    queryKey: queryKeys.streaks.all(),
    queryFn: async () => {
      const { data, error } = await api.GET('/api/v1/streaks');
      if (error) throw error;
      return data;
    },
    staleTime: 60_000,
  });
}
